"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexImportDataCable = exports.ChainflexImportDataCableSchema = void 0;
const zod_1 = require("zod");
const ChainflexImport_1 = require("./ChainflexImport");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
exports.ChainflexImportDataCableSchema = ChainflexImport_1.ChainflexImportSchema.extend({
    categories: zod_1.z.custom((cats) => {
        if (!Array.isArray(cats))
            return false;
        return cats.includes(echain_prisma_client_1.ChainflexCategory.DataCables);
    }),
    numberOfCoresCalculated: zod_1.z.number(),
});
const isChainflexImportDataCable = (whatever) => {
    var _a;
    return (_a = exports.ChainflexImportDataCableSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexImportDataCable = isChainflexImportDataCable;
//# sourceMappingURL=ChainflexImportDataCable.js.map